"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineHtmlRenderer = void 0;
var jquery_1 = __importDefault(require("jquery"));
var Widget_1 = require("../tools/Widget");
var debounce_1 = require("../tools/debounce");
var InlineHtmlRenderer = (function (_super) {
    __extends(InlineHtmlRenderer, _super);
    function InlineHtmlRenderer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InlineHtmlRenderer.prototype.init = function () {
        var _this = this;
        var iframe = document.createElement("iframe");
        var html = "<body><style>body{background:transparent;}</style>" + this.el.html() + "</body>";
        iframe.setAttribute("class", this.el.data("class"));
        iframe.setAttribute("scrolling", "no");
        this.el.before(iframe);
        iframe.contentWindow.document.open();
        iframe.contentWindow.document.write(html);
        iframe.contentWindow.document.close();
        this.iframe = iframe;
        this.$iframe = (0, jquery_1.default)(iframe);
        this.iframe.contentWindow.addEventListener("resize", (0, debounce_1.debounce)(function () {
            _this.resize();
        }));
        this.iframe.contentWindow.addEventListener("load", function () {
            _this.resize();
        });
    };
    InlineHtmlRenderer.prototype.resize = function () {
        var height = this.iframe.contentWindow.document.body.scrollHeight;
        this.$iframe.css("height", height + "px");
        this.$iframe.css("width", '100%');
    };
    return InlineHtmlRenderer;
}(Widget_1.Widget));
exports.InlineHtmlRenderer = InlineHtmlRenderer;
